import styled, { css } from 'styled-components';

import { getTypographyCSS } from 'components/UI/Typography';
import { Colors } from 'environment';
import { Disabled, generateSpacingOffsets } from 'helpers/cssGenerators';
import { SpacingOffsets } from 'types/index';

export const Container = styled.div<SpacingOffsets>`
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;

	/* SPACING OFFSETS */
	${({ marginOffset, paddingOffset }) => css`
		${generateSpacingOffsets({ paddingOffset, marginOffset })}
	`}
`;

export const Row = styled.div`
	display: flex;
`;

interface InputProps extends Disabled {
	readOnly?: boolean;
	error?: boolean;
	center?: boolean;
}

export const RegularInput = styled.input<InputProps>`
	/* REMOVE AUTOFIL BACKGROUND COLOR */
	:-webkit-autofill,
	:-webkit-autofill:hover,
	:-webkit-autofill:focus,
	:-webkit-autofill:active {
		box-shadow: 0 0 0px 100rem white inset !important;
	}

	@media print {
		background-color: ${Colors.gray.lightest};
	}

	${({ disabled, readOnly, error, center }) => css`
		/* TYPOGRAPHY SETTER */
		${getTypographyCSS(t => t.Paragraph)}

		height: 4rem;
		padding: 0.9rem 0.8rem;
		border-radius: 0.4rem;
		border: 0.12rem solid ${error ? Colors.text.error : Colors.text.disabled};
		background-color: ${Colors.white};
		width: 100%;
		text-align: ${center ? 'center' : 'left'};
		transition: 0.1s;

		:focus {
			border-color: ${error ? Colors.text.error : Colors.primary.normal};
			background-color: ${Colors.white};
			outline: unset;
			outline-offset: 0;
		}

		::placeholder,
		::-webkit-input-placeholder {
			color: ${Colors.text.caption};
		}

		${readOnly &&
		css`
			background-color: ${Colors.background.disabled};

			:focus {
				border-color: ${Colors.text.disabled};
				background-color: ${Colors.background.disabled};
			}
		`};

		${disabled &&
		css`
			pointer-events: none;
			background-color: ${Colors.background.disabled};
			border: 0.12rem solid ${Colors.background.disabled};

			color: ${Colors.text.disabled};

			::placeholder,
			::-webkit-input-placeholder {
				color: ${Colors.text.disabled};
			}
		`};
	`}
`;

type LabelHintProps = {
	noMargin?: boolean;
};

export const LabelHint = styled.p<LabelHintProps>`
	${({ noMargin }) => !noMargin && 'margin - left: 0.4rem'};
	${({ noMargin }) => !noMargin && 'margin-bottom: 0.4rem'};
	${getTypographyCSS(t => t.Caption)};
`;

export const TooltipWrapper = styled.div`
	margin-left: 0.5rem;
`;
